import React from 'react'

const PrivacyPopup = ({ onClose }) => {
  return (
    <>
      <div className="modal-overlay">
        <div className="modal">
          <div className="modal-head">
            <h2>개인정보 제 3자 제공에 대한 안내</h2>
          </div>
          <div className="modal-cont">
            <div className="policy-guide">
              <p>
                행정안전부 전자문서지갑포털 서비스(이하 “서비스”라 한다)와 관련하여 본인은 동의내용을 숙지하였으며, 이에 따라
                귀사(한국전자무역센터)가 수집한 본인의 개인정보를 아래와 같이 제3자에게 제공하는 것에 대해 동의합니다.
              </p>
              <p>
                <strong>가. 개인정보를 제공받는 자</strong>
                <br /> - 행정안전부 전자문서지갑포털
              </p>
              <p>
                <strong>나. 제공받는 자의 개인정보 이용목적</strong>
                <br /> - 전자증명서 발급
              </p>
              <p>
                <strong>다. 제공하는 개인정보 항목</strong>
              </p>
              <div className="tbl-wrap mt5">
                <table className="tbl-list">
                  <caption>문서명, 개인정보 수집 항목 항목으로 구성</caption>
                  <colgroup>
                    <col style={{ width: '50%' }} />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">문서명</th>
                      <th scope="col">개인정보 수집 항목</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>사업자등록증명</td>
                      <td>
                        [필수] 신청인 성명,
                        <br />
                        사업자등록번호
                      </td>
                    </tr>
                    <tr>
                      <td>운전경력증명서</td>
                      <td>[필수] 신청인 성명,</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <strong>라. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간</strong>
                <br /> - 제공받는자의 이용목적 달성시 까지
              </p>
              <p className="desc">
                ※ 고객은 개인정보의 제3자 제공에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 받는 별도의 불이익은 없습니다. 단,
                서비스 이용이 불가능하거나, 서비스 이용 목적에 따른 서비스 제공에 제한이 따르게 됩니다.
              </p>
            </div>
          </div>
          <div className="modal-foot">
            <button href="#" className="btn-primary md" onClick={() => onClose()}>
              확인
            </button>
          </div>
          <button type="button" className="modal-close b-close" onClick={() => onClose()}>
            창닫기
          </button>
        </div>
      </div>
    </>
  )
}

export default PrivacyPopup
